import GenericBanner from "@/components/GenericBanner";
import SearchBar from "@/components/SearchBar.js";
import Footer from "@/layout/Footer";
import React from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "../components/Card";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
const Product = () => {
	const marketplaceCards = [
		{
			id: 1,
			icon: "assets/product/xl/6thStreetLogo.svg",
			title: "6thStreet",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#E8ECEB",
		},

		{
			id: 2,
			icon: "assets/product/xl/alibabaLogo.svg",
			title: "AliBaba",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(255, 90, 0, 0.2)",
		},

		{
			id: 3,
			icon: "assets/product/xl/aliExpressLogo.svg",
			title: "Ali Express",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(288, 50, 37, 0.2)",
		},
		{
			id: 4,
			icon: "assets/product/xl/amazonLogo.svg",
			title: "Amazon",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(255, 153, 0, 0.2)",
		},
		{
			id: 5,
			icon: "assets/product/xl/carrefourLogo.svg",
			title: "Carrefour",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(238, 37, 39, 0.2)",
		},
		{
			id: 6,
			icon: "assets/product/xl/ebayLogo.svg",
			title: "Ebay",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(134, 184, 23, 0.2)",
		},
		{
			id: 7,
			icon: "assets/product/xl/flipkartLogo.svg",
			title: "Flipkart",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(248, 229, 44, 0.2)",
		},
		{
			id: 8,
			icon: "assets/product/xl/jdcomLogo.svg",
			title: "JD Global",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(228, 29, 0, 0.2)",
		},
		{
			id: 9,
			icon: "assets/product/xl/jumboLogo.svg",
			title: "Jumbo",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(0, 70, 132, 0.2)",
		},
		{
			id: 10,
			icon: "assets/product/xl/marksSpencerLogo.svg",
			title: "Marks & Spencer",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(223, 210, 28, 0.2)",
		},
		{
			id: 11,
			icon: "assets/product/xl/myntaraLogo.svg",
			title: "Myntra",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(244, 28, 178, 0.2)",
		},
		{
			id: 12,
			icon: "assets/product/xl/namshiLogo.svg",
			title: "Namshi",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(176, 176, 176, 0.2)",
		},
		{
			id: 13,
			icon: "assets/product/xl/noonLogo.svg",
			title: "Noon",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(252, 238, 18, 0.2)",
		},
		{
			id: 14,
			icon: "assets/product/xl/sharafDGLogo.svg",
			title: "Sharaf DG",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(255, 173, 27, 0.2)",
		},
		{
			id: 15,
			icon: "assets/product/xl/superMartLogo.svg",
			title: "Supermart",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "#FFFFF",
		},
		{
			id: 16,
			icon: "assets/product/xl/tmallLogo.svg",
			title: "TMALL",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(255, 0, 43, 0.2)",
		},
		{
			id: 17,
			icon: "assets/product/xl/walmartLogo.svg",
			title: "Walmart",
			productsCount: "+10,000 products listed",
			categories: "Electronics, Home & Kitchen, Apparel",
			bgColor: "rgba(0, 113, 220, 0.2)",
		},
	];
	const sixthStreetTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/0/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/6thStreetLogo.svg",
			platformName: "6thStreet",
		},
		{
			id: 2,
			image: "assets/product/xl/0/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/6thStreetLogo.svg",
			platformName: "6thStreet",
		},
		{
			id: 3,
			image: "assets/product/xl/0/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/6thStreetLogo.svg",
			platformName: "6thStreet",
		},
		{
			id: 4,
			image: "assets/product/xl/0/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/6thStreetLogo.svg",
			platformName: "6thStreet",
		},
		{
			id: 5,
			image: "assets/product/xl/0/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/6thStreetLogo.svg",
			platformName: "6thStreet",
		},
	];
	const aliBabaTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/1/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/alibabaLogo.svg",
			platformName: "AliBaba",
		},
		{
			id: 2,
			image: "assets/product/xl/1/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/alibabaLogo.svg",
			platformName: "AliBaba",
		},
		{
			id: 3,
			image: "assets/product/xl/1/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/alibabaLogo.svg",
			platformName: "AliBaba",
		},
		{
			id: 4,
			image: "assets/product/xl/1/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/alibabaLogo.svg",
			platformName: "AliBaba",
		},
		{
			id: 5,
			image: "assets/product/xl/1/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/alibabaLogo.svg",
			platformName: "AliBaba",
		},
	];
	const aliExpressSellers = [
		{
			id: 1,
			image: "assets/product/xl/2/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/aliExpressLogo.svg",
			platformName: "Ali Express",
		},
		{
			id: 2,
			image: "assets/product/xl/2/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/aliExpressLogo.svg",
			platformName: "Ali Express",
		},
		{
			id: 3,
			image: "assets/product/xl/2/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/aliExpressLogo.svg",
			platformName: "Ali Express",
		},
		{
			id: 4,
			image: "assets/product/xl/2/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/aliExpressLogo.svg",
			platformName: "Ali Express",
		},
		{
			id: 5,
			image: "assets/product/xl/2/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/aliExpressLogo.svg",
			platformName: "Ali Express",
		},
	];
	const amazonTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/3/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonLogo.svg",
			platformName: "Amazon",
		},
		{
			id: 2,
			image: "assets/product/xl/3/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonLogo.svg",
			platformName: "Amazon",
		},
		{
			id: 3,
			image: "assets/product/xl/3/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/amazonLogo.svg",
			platformName: "Amazon",
		},
		{
			id: 4,
			image: "assets/product/xl/3/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonLogo.svg",
			platformName: "Amazon",
		},
		{
			id: 5,
			image: "assets/product/xl/3/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/amazonLogo.svg",
			platformName: "Amazon",
		},
	];
	const carrefourTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/4/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/carrefourLogo.svg",
			platformName: "Carrefour",
		},
		{
			id: 2,
			image: "assets/product/xl/4/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/carrefourLogo.svg",
			platformName: "Carrefour",
		},
		{
			id: 3,
			image: "assets/product/xl/4/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/carrefourLogo.svg",
			platformName: "Carrefour",
		},
		{
			id: 4,
			image: "assets/product/xl/4/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/carrefourLogo.svg",
			platformName: "Carrefour",
		},
		{
			id: 5,
			image: "assets/product/xl/4/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/carrefourLogo.svg",
			platformName: "Carrefour",
		},
	];
	const ebayTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/5/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/ebayLogo.svg",
			platformName: "Ebay",
		},
		{
			id: 2,
			image: "assets/product/xl/5/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/ebayLogo.svg",
			platformName: "Ebay",
		},
		{
			id: 3,
			image: "assets/product/xl/5/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/ebayLogo.svg",
			platformName: "Ebay",
		},
		{
			id: 4,
			image: "assets/product/xl/5/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/ebayLogo.svg",
			platformName: "Ebay",
		},
		{
			id: 5,
			image: "assets/product/xl/5/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/ebayLogo.svg",
			platformName: "Ebay",
		},
	];
	const flipkartTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/6/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/flipkartLogo.svg",
			platformName: "Flipkart",
		},
		{
			id: 2,
			image: "assets/product/xl/6/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/flipkartLogo.svg",
			platformName: "Flipkart",
		},
		{
			id: 3,
			image: "assets/product/xl/6/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/flipkartLogo.svg",
			platformName: "Flipkart",
		},
		{
			id: 4,
			image: "assets/product/xl/6/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/flipkartLogo.svg",
			platformName: "Flipkart",
		},
		{
			id: 5,
			image: "assets/product/xl/6/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/flipkartLogo.svg",
			platformName: "Flipkart",
		},
	];
	const jdGlobalTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/7/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/jdcomLogo.svg",
			platformName: "JD Global",
		},
		{
			id: 2,
			image: "assets/product/xl/7/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jdcomLogo.svg",
			platformName: "JD Global",
		},
		{
			id: 3,
			image: "assets/product/xl/7/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/jdcomLogo.svg",
			platformName: "JD Global",
		},
		{
			id: 4,
			image: "assets/product/xl/7/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jdcomLogo.svg",
			platformName: "JD Global",
		},
		{
			id: 5,
			image: "assets/product/xl/7/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jdcomLogo.svg",
			platformName: "JD Global",
		},
	];
	const jumboTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/8/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/jumboLogo.svg",
			platformName: "Jumbo",
		},
		{
			id: 2,
			image: "assets/product/xl/8/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jumboLogo.svg",
			platformName: "Jumbo",
		},
		{
			id: 3,
			image: "assets/product/xl/8/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/jumboLogo.svg",
			platformName: "Jumbo",
		},
		{
			id: 4,
			image: "assets/product/xl/8/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jumboLogo.svg",
			platformName: "Jumbo",
		},
		{
			id: 5,
			image: "assets/product/xl/8/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/jumboLogo.svg",
			platformName: "Jumbo",
		},
	];

	const marksSpencerTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/9/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/marksSpencerLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 2,
			image: "assets/product/xl/9/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/marksSpencerLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 3,
			image: "assets/product/xl/9/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/marksSpencerLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 4,
			image: "assets/product/xl/9/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/marksSpencerLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 5,
			image: "assets/product/xl/9/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/marksSpencerLogo.svg",
			platformName: "Marks & Spencer",
		},
	];
	const myntraTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/10/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/myntaraLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 2,
			image: "assets/product/xl/10/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/myntaraLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 3,
			image: "assets/product/xl/10/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/myntaraLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 4,
			image: "assets/product/xl/10/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/myntaraLogo.svg",
			platformName: "Marks & Spencer",
		},
		{
			id: 5,
			image: "assets/product/xl/10/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/myntaraLogo.svg",
			platformName: "Marks & Spencer",
		},
	];
	const namshiTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/12/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/namshiLogo.svg",
			platformName: "Namshi",
		},
		{
			id: 2,
			image: "assets/product/xl/12/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/namshiLogo.svg",
			platformName: "Namshi",
		},
		{
			id: 3,
			image: "assets/product/xl/12/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/namshiLogo.svg",
			platformName: "Namshi",
		},
		{
			id: 4,
			image: "assets/product/xl/12/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/namshiLogo.svg",
			platformName: "Namshi",
		},
		{
			id: 5,
			image: "assets/product/xl/12/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/namshiLogo.svg",
			platformName: "Namshi",
		},
	];
	const noonTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/12/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/noonLogo.svg",
			platformName: "Noon",
		},
		{
			id: 2,
			image: "assets/product/xl/12/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/noonLogo.svg",
			platformName: "Noon",
		},
		{
			id: 3,
			image: "assets/product/xl/12/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/noonLogo.svg",
			platformName: "Noon",
		},
		{
			id: 4,
			image: "assets/product/xl/12/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/noonLogo.svg",
			platformName: "Noon",
		},
		{
			id: 5,
			image: "assets/product/xl/12/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/noonLogo.svg",
			platformName: "Noon",
		},
	];
	const sharafDGTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/13/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/sharafDGLogo.svg",
			platformName: "Noon",
		},
		{
			id: 2,
			image: "assets/product/xl/13/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/sharafDGLogo.svg",
			platformName: "Noon",
		},
		{
			id: 3,
			image: "assets/product/xl/13/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/sharafDGLogo.svg",
			platformName: "Noon",
		},
		{
			id: 4,
			image: "assets/product/xl/13/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/sharafDGLogo.svg",
			platformName: "Noon",
		},
		{
			id: 5,
			image: "assets/product/xl/13/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/sharafDGLogo.svg",
			platformName: "Noon",
		},
	];
	const supermartTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/14/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 2,
			image: "assets/product/xl/14/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 3,
			image: "assets/product/xl/14/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 4,
			image: "assets/product/xl/14/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 5,
			image: "assets/product/xl/14/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
	];
	const tmallTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/15/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 2,
			image: "assets/product/xl/15/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 3,
			image: "assets/product/xl/15/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 4,
			image: "assets/product/xl/15/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 5,
			image: "assets/product/xl/15/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/superMartLogo.svg",
			platformName: "Noon",
		},
	];
	const walmartTopSellers = [
		{
			id: 1,
			image: "assets/product/xl/16/img1.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/walmartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 2,
			image: "assets/product/xl/16/img2.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/walmartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 3,
			image: "assets/product/xl/16/img3.svg",
			priceRange: "$229 - 239",
			minOrder: "10 pieces",
			shippingRange: "From 29 to 49 USD",
			platformIcon: "assets/product/xl/walmartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 4,
			image: "assets/product/xl/16/img4.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/walmartLogo.svg",
			platformName: "Noon",
		},
		{
			id: 5,
			image: "assets/product/xl/16/img5.svg",
			priceRange: "$229 - 239",
			minOrder: "5 pieces",
			shippingRange: "From 25 to 45 USD",
			platformIcon: "assets/product/xl/walmartLogo.svg",
			platformName: "Noon",
		},
	];

	const categoriesCardRow1 = [
		{
			image: "/assets/home/section6/watch.png",
			title: "Electronic Devices",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/electric_tools.png",
			title: "Electronic Tools",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/gifts.png",
			title: "Gifts",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/hardware.png",
			title: "Hardware",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
		{
			image: "/assets/home/section6/health_beauty.png",
			title: "Health & Beauty",
			description: "Smart Watches",
			priceRange: "From 29 to 49 USD",
			category: "Laptops & PC",
		},
	];
	const colorClassMap = {
		product: "bg-[#D2DCD1]",
	};
	return (
		<>
			<SearchBar />
			<div className="flex flex-col gap-[30px]">
				<GenericBanner
					iconSrc="/assets/product/xl/bannerLogo.svg"
					title="Best Marketplaces for Dropshipping"
					subtitle="+10,000 products listed"
					description="Find trending products for dropshipping among trusted and reliable suppliers across the globe."
					bgColor={colorClassMap["product"]}
				/>

				<div className="flex flex-col w-full  xl:w-[90%] mx-auto  h-[2238px]  gap-[21px] hidden my-[20px] lg:flex">
					<div className="w-[1256px] h-[52px] gap-[10px]">
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-left text-[#193D34]">
							Top marketplaces to find winning dropshipping products
						</h1>
					</div>
					{/* Cards container */}

					<div className="grid grid-cols-3 gap-[32px] w-full xl:w-[98%] mx-auto">
						{marketplaceCards.slice(0, 15).map((card) => (
							<Card key={card.id} content={card} variant="marketplaceCards" />
						))}
					</div>
					{/* Top Row: First 3 cards */}
					<div className="w-full flex flex-row items-center justify-center gap-[26px] mx-auto">
						{marketplaceCards.slice(15, 17).map((card) => (
							<Card key={card.id} content={card} variant="marketplaceCards2" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[0]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{sixthStreetTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[1]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{aliBabaTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[2]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{aliExpressSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[3]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{amazonTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>

				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[4]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{carrefourTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>

				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[5]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{ebayTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[6]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{flipkartTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[7]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{jdGlobalTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[8]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{jumboTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[9]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{marksSpencerTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>

				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[10]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{myntraTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[11]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{namshiTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[12]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{noonTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[12]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{noonTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[13]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{sharafDGTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[14]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{supermartTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[15]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{tmallTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col    w-full xl:w-[90%] mx-auto  h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							{marketplaceCards[16]["title"]} Top Sellers
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-5 gap-[80px]">
						{walmartTopSellers.map((card) => (
							<Card key={card.id} content={card} variant="topSellers" />
						))}
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto  h-auto   gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					{/* Cards container */}
					<div className="w-full  h-[52px] flex items-center">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] tracking-normal text-[#193D34]">
							Browse by categories...
						</h1>

						<div className="flex items-center gap-[4px] rounded-[24px] p-[8px] bg-white h-[32px] w-[98px] ml-2">
							<span className="font-montserrat font-medium text-[13px] leading-[24px] tracking-normal text-[#193D34]">
								See More
							</span>
							<div className="w-[16px] h-[16px] flex items-center justify-center">
								<img
									src="assets/product/xl/amazonTopSellers/seeMore.svg"
									alt="See More"
									className="w-full h-full"
								/>
							</div>
						</div>
					</div>
					<div className="relative w-full flex justify-center">
						{/* Swiper Navigation Buttons */}
						<button className="custom-prev absolute left-[-10px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 ml-[-40px] swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>
						<button className="custom-next absolute right-[-50px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper Slider */}
						<Swiper
							modules={[Navigation]}
							navigation={{
								nextEl: ".custom-next",
								prevEl: ".custom-prev",
							}}
							slidesPerView="auto"
							spaceBetween={80}
							className="w-full"
						>
							{categoriesCardRow1.map((card) => (
								<SwiperSlide
									key={card.id}
									className="!w-[calc((100%-4*80px)/5)]" // Make 5 cards fit with 4 gaps of 80px
								>
									<Card content={card} variant="categories" />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto  h-auto   gap-[21px]  hidden mt-[220px] lg:flex mt-[20px]">
					<div className="w-full  h-[826px] left-[85px] flex flex-col gap-[16px] hidden lg:flex">
						{/* First Paragraph */}
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-black align-middle">
							Make 2025 The Best Yet with Our Dropshipping Automation Software
						</p>

						{/* Second Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							To thrive and beat the competition in 2025, drop shippers must
							understand market dynamics and cater to audiences with competitive
							products that they are actively looking for.
							<br /> When you use Rbetraj's{" "}
							<b>dropshipping automation software</b>, you get to beat the tough
							competition and stay on top by selling high-demand products that
							will boost sales of your dropshipping store and build trust among
							your customers.
						</p>

						{/* Third Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black align-middle">
							Use our Dropshipping product research software to find trending
							dropshipping products
						</p>

						{/* Fourth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							With advanced filters, such as price comparison, social media
							reviews, location, product quality, and stock availability, our
							dropshipping product research software enables you to find niche
							and winning products that are highly likely to be bought by
							customers.
							<br />
							<br />
							While our tool automates this crucial step, you save a huge chunk
							of your time, giving yourself more room to expand your business
							and indulge in the creative aspects of your store.
							<br />
							<br />
							Take a look at our top reliable suppliers and how our dropshipping
							tool will help you manoeuvre these massive platforms.
						</p>

						{/* Fifth Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black align-middle">
							Leverage The Best Dropshipping Automation Software For Amazon
						</p>

						{/* Sixth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							Amazon is, by far, the most used and trusted dropshipping
							marketplace across the globe.
							<br />
							<br /> But like most huge marketplaces, finding products, creating
							product listings, and managing inventory can seem a little
							intimidating for new dropshippers. However, with our Amazon
							dropshipping automation software, key steps are automated, making
							the whole dropshipping process a lot more quicker and easier.
							<br />
							<br />
							With advanced AI algorithms, you will drastically reduce human
							errors and make decisions with precision-based insights.
						</p>

						{/* Seventh Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal align-middle">
							Source the Best Products with{" "}
							<b>Walmart Dropshipping Product Finder</b>
						</p>

						{/* Eighth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal text-black">
							Walmart is a household name trusted by millions of customers. It
							offers great deals on really competitive prices, good quality
							products, and faster shipping times.
							<br />
							<br /> Dropshippers turn to Walmart to find trending dropshipping
							products at significant markdowns.
							<br /> Rbetraj's <b>Walmart Dropshipping Product Finder</b> is a
							great tool for finding products that are trending in your niche
							and region. It will give you the much-needed clarity to choose
							profit-earning products.
						</p>

						{/* Ninth Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal align-middle">
							Find Winning Products with our Alibaba Dropshipping Automation
							Software
						</p>

						{/* Tenth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal">
							Alibaba is another huge global e-commerce platform that offers
							millions of products and has a wide network of drop-shipping
							partners. It connects more than 150,000 Chinese wholesalers to
							drop-shippers worldwide, making it one of the busiest e-commerce
							platforms.
							<br />
							<br />
							With such a huge database and so many varieties of products, it
							can be cumbersome to find high-profit items for your store.
							<br />
							<br /> When you use our Alibaba Dropshipping Software, you can
							find products with great deals, check stock availability, and
							identity products with the best customer reviews.
							<br />
						</p>

						{/* Eleventh Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal align-middle">
							Use our eBay Product Research Software To Source Billions of
							Products
						</p>

						{/* Twelfth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal">
							eBay has more than 1.6 billion listings on its marketplace.
							Therefore, it becomes more critical to find products that can
							generate high revenues.
							<br />
							<br /> Our eBay product research software automates the whole
							process, saves you time by finding the best products and helps you
							tackle the fierce competition by doing the groundwork for you.
						</p>

						{/* Thirteenth Paragraph */}
						<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal align-middle text-black">
							Try AliExpress Dropshipping Automation Software For Global
							Suppliers
						</p>

						{/* Fourteenth Paragraph */}
						<p className="font-montserrat font-normal text-[12px] leading-[12px] tracking-normal">
							Owned by China-based eComm giant, Alibaba, AliExpress sells
							millions of products on their marketplace. AliExpress's framework
							is also known to be highly dropshipper friendly hence is a great
							starting point if you want to start off with your dropshipping
							journey.
						</p>
					</div>
				</div>
			</div>
			{/*Mobile view*/}
			<div className="lg:hidden w-full h-[268px] pt-4 pr-5 pb-4 pl-5 gap-4 bg-[#193D34]">
				{/* Navigation Tabs */}
				<div className="w-[378px] h-[36px] pr-5 pb-2 pl-1 gap-1 flex items-center mt-4">
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Products
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Shops
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Trends
						</span>
					</div>
				</div>

				<div className="w-[338px] h-[40px] rounded-lg border-[1.6px] border-gray-300 overflow-hidden mt-3">
					<div className="relative flex items-center w-full h-full">
						<input
							type="text"
							placeholder="Search product.."
							className="pl-4 pr-12 w-full h-full bg-white text-black placeholder:text-gray-400 outline-none focus:ring-0"
						/>
						<button className="absolute right-0 flex items-center justify-center w-[40px] h-full bg-[#B7D974] hover:bg-[#A9C864] transition-colors">
							<img
								src="/assets/home/topnav/search.png"
								alt="Search"
								className="w-[20px] h-[20px]"
							/>
						</button>
					</div>
				</div>

				<div className="lg:hidden w-[338px] flex flex-wrap items-center mt-6 gap-4">
					{/* Filter By Label */}
					<span className="font-montserrat font-normal text-[16px] leading-[32px] text-[#F6F6F6] whitespace-nowrap">
						Filter By :
					</span>

					{/* Buttons */}
					{[
						"Top Sellers",
						"Only Amazon",
						"Only Alibaba",
						"Top in Marketplace",
					].map((label, index) => (
						<button
							key={index}
							className="object-contain  h-[30px] px-[12px] py-[8px] flex items-center justify-center gap-[10px] rounded-[20px] border border-[#A7C56A] bg-[#47645D]"
						>
							<span className="whitespace-nowrap  font-montserrat font-medium text-[13px] leading-[100%] tracking-[0%] text-center text-white">
								{label}
							</span>
						</button>
					))}
				</div>
			</div>

			<div className="w-full lg:hidden flex flex-col items-center">
				{/* Icon container with background */}
				<div className="w-full h-[130px] flex items-center justify-center bg-[#D2DCD1]">
					<div className="w-[378px] h-full flex items-center justify-center">
						<img
							src="assets/product/mobile/rbetrajLogo.svg"
							alt="Icon"
							className="max-w-full max-h-full object-center object-contain"
						/>
					</div>
				</div>

				{/* Text content container */}
				<div className="w-full flex items-center justify-center bg-[#E8ECEB] py-4">
					<div className="w-[378px] flex flex-col items-start text-left space-y-1">
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-[#193D34]">
							Best Marketplaces for Dropshipping
						</p>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
							+10,000 products listed
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A]">
							Find trending products for dropshipping among trusted and reliable
							suppliers across the globe.
						</p>
					</div>
				</div>
			</div>
			<div className="w-full lg:hidden flex items-center justify-between px-2 my-8">
				{/* Breadcrumbs */}
				<div className="flex items-center space-x-2 overflow-x-auto">
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Trends
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Facebook
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Tagsword
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
				</div>

				{/* Sort By Button */}
				<button className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2">
					<img
						src="assets/product/mobile/sortIconStart.svg"
						alt="start icon"
						className="w-[16px] h-[16px]"
					/>
					<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
						Sort by
					</span>
					<img
						src="assets/product/mobile/sortIconEnd.svg"
						alt="end icon"
						className="w-[16px] h-[16px]"
					/>
				</button>
			</div>

			<div className="grid grid-cols-1 gap-[30px]  w-full block lg:hidden my-20">
				{marketplaceCards.map((card) => (
					<Card key={card.id} content={card} variant="marketplaceCards" />
				))}
			</div>

			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[0]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{sixthStreetTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[1]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{aliBabaTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[2]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{aliExpressSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[3]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{amazonTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[4]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{carrefourTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[5]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{ebayTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[6]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{flipkartTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[7]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{jdGlobalTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[8]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{jumboTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[9]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{marksSpencerTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[10]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{myntraTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[11]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{namshiTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[13]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{noonTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[14]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{sharafDGTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[14]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{supermartTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[15]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{tmallTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="w-full h-[390px] bg-[#CFE6A2] flex flex-col items-center sm:flex lg:hidden mb-[100px]">
				{/* Wrapper for Title and Swiper */}
				<div className="w-full flex flex-col items-center px-4 py-6">
					{/* Title */}
					<div className="w-full text-[#193D34] text-[22px] font-semibold leading-[28px] font-[Montserrat] text-center mb-4">
						{marketplaceCards[16]["title"]} Top Sellers
					</div>

					{/* Swiper Container */}
					<div className="w-full flex flex-col items-center justify-center relative">
						{/* Custom Navigation Buttons */}
						<img
							src="/assets/home/section3/navigationButtonLeft.svg"
							alt="prev"
							className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>
						<img
							src="/assets/home/section3/navigationButtonRight.svg"
							alt="next"
							className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
						/>

						{/* Swiper */}
						<div className="w-full flex justify-center">
							<Swiper
								modules={[Navigation, Pagination]}
								spaceBetween={10}
								slidesPerView={2}
								breakpoints={{
									481: { slidesPerView: 1.5, spaceBetween: 10 },
									768: { slidesPerView: 2.5, spaceBetween: 16 },
									1024: { slidesPerView: 3.5, spaceBetween: 24 },
								}}
								navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
								pagination={{
									el: ".custom-pagination",
									clickable: true,
									dynamicBullets: true,
								}}
								className="w-full"
							>
								{walmartTopSellers.map((card) => (
									<SwiperSlide key={card.id}>
										<Card variant="topSellers" content={card} />
									</SwiperSlide>
								))}
							</Swiper>
						</div>

						{/* Custom Pagination */}
						<div className="custom-pagination mt-4 flex justify-center w-full"></div>
					</div>
				</div>
			</div>
			<div className="flex flex-col w-full px-4 gap-[16px] my-4 lg:hidden">
				{/* Title */}
				<p className="font-montserrat font-bold text-[16px] leading-[24px] text-black">
					Make 2025 The Best Yet with Our Dropshipping Automation Software
				</p>

				{/* Paragraph 1 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					To thrive and beat the competition in 2025, drop shippers must
					understand market dynamics and cater to audiences with competitive
					products that they are actively looking for.
					<br />
					When you use Rbetraj's <b>dropshipping automation software</b>, you
					get to beat the tough competition and stay on top by selling
					high-demand products that will boost sales of your dropshipping store
					and build trust among your customers.
				</p>

				{/* Paragraph 2 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Use our Dropshipping product research software to find trending
					dropshipping products
				</p>

				{/* Paragraph 3 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					With advanced filters, such as price comparison, social media reviews,
					location, product quality, and stock availability, our dropshipping
					product research software enables you to find niche and winning
					products that are highly likely to be bought by customers.
					<br />
					<br />
					While our tool automates this crucial step, you save a huge chunk of
					your time, giving yourself more room to expand your business and
					indulge in the creative aspects of your store.
					<br />
					<br />
					Take a look at our top reliable suppliers and how our dropshipping
					tool will help you manoeuvre these massive platforms.
				</p>

				{/* Paragraph 4 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Leverage The Best Dropshipping Automation Software For Amazon
				</p>

				{/* Paragraph 5 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					Amazon is, by far, the most used and trusted dropshipping marketplace
					across the globe.
					<br />
					<br />
					But like most huge marketplaces, finding products, creating product
					listings, and managing inventory can seem a little intimidating for
					new dropshippers. However, with our Amazon dropshipping automation
					software, key steps are automated, making the whole dropshipping
					process a lot more quicker and easier.
					<br />
					<br />
					With advanced AI algorithms, you will drastically reduce human errors
					and make decisions with precision-based insights.
				</p>

				{/* Paragraph 6 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Source the Best Products with{" "}
					<b>Walmart Dropshipping Product Finder</b>
				</p>

				{/* Paragraph 7 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					Walmart is a household name trusted by millions of customers. It
					offers great deals on really competitive prices, good quality
					products, and faster shipping times.
					<br />
					<br />
					Dropshippers turn to Walmart to find trending dropshipping products at
					significant markdowns.
					<br />
					Rbetraj's <b>Walmart Dropshipping Product Finder</b> is a great tool
					for finding products that are trending in your niche and region. It
					will give you the much-needed clarity to choose profit-earning
					products.
				</p>

				{/* Paragraph 8 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Find Winning Products with our Alibaba Dropshipping Automation
					Software
				</p>

				{/* Paragraph 9 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					Alibaba is another huge global e-commerce platform that offers
					millions of products and has a wide network of drop-shipping partners.
					It connects more than 150,000 Chinese wholesalers to drop-shippers
					worldwide, making it one of the busiest e-commerce platforms.
					<br />
					<br />
					With such a huge database and so many varieties of products, it can be
					cumbersome to find high-profit items for your store.
					<br />
					<br />
					When you use our Alibaba Dropshipping Software, you can find products
					with great deals, check stock availability, and identity products with
					the best customer reviews.
				</p>

				{/* Paragraph 10 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Use our eBay Product Research Software To Source Billions of Products
				</p>

				{/* Paragraph 11 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					eBay has more than 1.6 billion listings on its marketplace. Therefore,
					it becomes more critical to find products that can generate high
					revenues.
					<br />
					<br />
					Our eBay product research software automates the whole process, saves
					you time by finding the best products and helps you tackle the fierce
					competition by doing the groundwork for you.
				</p>

				{/* Paragraph 12 */}
				<p className="font-montserrat font-semibold text-[13px] leading-[20px] text-black">
					Try AliExpress Dropshipping Automation Software For Global Suppliers
				</p>

				{/* Paragraph 13 */}
				<p className="font-montserrat text-[12px] leading-[18px] text-black">
					Owned by China-based eComm giant, Alibaba, AliExpress sells millions
					of products on their marketplace. AliExpress's framework is also known
					to be highly dropshipper friendly hence is a great starting point if
					you want to start off with your dropshipping journey.
				</p>
			</div>

			<Footer />
		</>
	);
};

export default Product;
